// mainOrdersPage.jsx
import React from "react";
import OrdersPage from "./OrdersPage";

const MainOrdersPage = () => {
  return (
    <div className=" min-h-screen lg:w-[75vw] max-w-[100vw]  pt-2 overflow-auto items-center mx-auto">
      
        {/* <div className="w-full overflow-x-hidden"> */}
          <OrdersPage />
     
      {/* </div> */}
    </div>
  );
};

export default MainOrdersPage;
